import React from 'react';
import { Row, Col, Card, Typography, Space } from 'antd';
import ResumeBarChart from '../../graphics/resumeBarChart';
import ScoreTierLegend from '../scoreTierLegend/scoreTierLegend';
import { formatVisiblePercent, getEvaluationScoreColor, isIpraService } from '../selfcare360/selfcare360Scales';

const { Text } = Typography;

const LeadershipSummary = ({ data, globalAverage, title, redLight, yellowLight, isMain, serviceId }) => {
    const dimensions = Object.entries(data?.average_by_dimension || {})
        .filter(([key, _]) => !key.toLowerCase().includes("general"))
        .map(([_, value]) => value);
    if (dimensions.length === 0) return null;

    const best = dimensions.reduce((max, d) => (d.average > max.average ? d : max), dimensions[0]);
    const worst = dimensions.reduce((min, d) => (d.average < min.average ? d : min), dimensions[0]);

    const serviceIsIpra = isIpraService(serviceId);
    const summaryLabel = serviceIsIpra ? 'IPRA global' : 'Global Compañía';

    const getContrastTextColor = (bgColor) =>
        String(bgColor).toLowerCase() === '#fbc02d' ? '#000' : '#fff';

    const globalBgColor = getEvaluationScoreColor(globalAverage, { redLight, yellowLight, serviceId });
    const globalTextColor = getContrastTextColor(globalBgColor);

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Row gutter={[16, 16]} align="stretch">
                <Col xs={24} md={16}>
                    <ScoreTierLegend redLight={redLight} yellowLight={yellowLight} serviceId={serviceId} />
                </Col>
                <Col xs={24} md={8} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Card
                        style={{
                            backgroundColor: globalBgColor,
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: "100%",
                            width: "100%"
                        }}
                    >
                        <Text style={{ fontSize: 16, marginBottom: 10, color: globalTextColor }}>{summaryLabel}</Text>
                        <br></br>
                        <Text style={{ fontSize: 32, fontWeight: "bold", color: globalTextColor }}>{formatVisiblePercent(globalAverage)}</Text>
                    </Card>
                </Col>
            </Row>

            {/* Gráfico y promedio global */}
            <Row gutter={[16, 16]}>
                <Col xs={24} md={24}>
                    <ResumeBarChart data={dimensions} redLight={redLight} yellowLight={yellowLight} serviceId={serviceId} />
                </Col>
            </Row>

            {
                !isMain && <>
                    {/* Análisis centrado */}
                    <Row gutter={[16, 16]} align="stretch">
                        <Col xs={24} md={24}>
                            <Card bordered style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                                <Text style={{ fontSize: '16px', lineHeight: 1.8 }}>
                                    El <Text strong>{title}</Text> de la empresa es de <Text strong>{formatVisiblePercent(globalAverage)}</Text>, donde la categoría mejor evaluada es <Text strong>{best.title}</Text> con <Text strong>{formatVisiblePercent(best.average)}</Text>, y la de menor resultado fue <Text strong>{worst.title}</Text> con <Text strong>{formatVisiblePercent(worst.average)}</Text>.
                                </Text>
                            </Card>
                        </Col>
                    </Row>
                </>
            }
        </Space>
    );
};

export default LeadershipSummary;
